import { useTranslation } from 'react-i18next';
import { Button, Dialog, Heading, Paragraph } from '@digdir/designsystemet-react';
import classes from '../SurveysPage.module.css';

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  text: string;
  confirmLabel: string;
  dismissLabel: string;
  isPending?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/** Bekreftelse før en handling som ikke kan angres. */
export const ConfirmDialog = ({
  open,
  title,
  text,
  confirmLabel,
  dismissLabel,
  isPending = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      closedby="any"
      closeButton={t('surveys.page.closeDialog')}
      className={classes.dialog}
    >
      <div className={classes.dialogContent}>
        <Heading level={2} data-size="sm">
          {title}
        </Heading>
        <Paragraph>{text}</Paragraph>
        <div className={classes.dialogButtons}>
          <Button data-color="danger" onClick={onConfirm} disabled={isPending}>
            {confirmLabel}
          </Button>
          <Button variant="tertiary" onClick={onClose}>
            {dismissLabel}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
